import React from "react";

export const Skype = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width   = {props.width || "28"}
    height  = {props.width || "28"}
    viewBox="0 0 1000 990"
    fill    = {props.color || "#fff"}
    {...props}
  >
    <defs>
      <linearGradient
        id="a"
        x1={8.393}
        y1={1.106}
        x2={11.125}
        y2={18.354}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.012} stopColor="#00b7f0" />
        <stop offset={0.339} stopColor="#009de5" />
        <stop offset={0.755} stopColor="#0082d9" />
        <stop offset={1} stopColor="#0078d4" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={14.379}
        y1={26.645}
        x2={29.546}
        y2={17.889}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0078d4" />
        <stop offset={0.37} stopColor="#007ad5" />
        <stop offset={0.573} stopColor="#0082d9" />
        <stop offset={0.735} stopColor="#0090df" />
        <stop offset={0.875} stopColor="#00a3e7" />
        <stop offset={1} stopColor="#00bcf2" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={10.45}
        y1={6.689}
        x2={24.291}
        y2={30.662}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00b7f0" />
        <stop offset={1} stopColor="#007cc1" />
      </linearGradient>
    </defs>
    <path
      d="M18.518 9.73a8.759 8.73 0 0 1-8.759 8.73A8.759 8.73 0 0 1 1 9.73 8.759 8.73 0 0 1 9.759 1a8.759 8.73 0 0 1 8.759 8.73"
      transform="matrix(33.33333 0 0 33.33333 -33.333 -33.333)"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M30.725 22.267A8.762 8.733 0 0 1 21.963 31a8.762 8.733 0 0 1-8.762-8.733 8.762 8.733 0 0 1 8.762-8.733 8.762 8.733 0 0 1 8.762 8.733"
      transform="matrix(33.33333 0 0 33.33333 -33.333 -33.333)"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M1.067 315.9A291.933 291.933 0 1 0 328.3 2.233 530.5 530.5 0 0 0 1.067 315.9z"
      fillRule="evenodd"
      opacity={0.05}
    />
    <path
      d="M990.067 688A292.033 292.033 0 1 0 672.3 998.8a530.5 530.5 0 0 0 317.767-310.833z"
      fillRule="evenodd"
      opacity={0.05}
    />
    <path
      d="M14.733 382.433a291.833 291.833 0 1 0 379.934-363.9 496.433 496.433 0 0 0-379.934 363.9z"
      fillRule="evenodd"
      opacity={0.1}
    />
    <path
      d="M976.8 619.6a291.933 291.933 0 1 0-373.067 364.633A496.433 496.433 0 0 0 976.8 619.6z"
      fillRule="evenodd"
      opacity={0.1}
    />
    <path
      d="M25.467 410.033A291.767 291.767 0 1 0 421.933 30.367 479.567 479.567 0 0 0 25.467 410.033z"
      fillRule="evenodd"
      opacity={0.1}
    />
    <path
      d="M966.033 591.433A291.867 291.867 0 1 0 575.6 972.9a479.533 479.533 0 0 0 390.433-381.467z"
      fillRule="evenodd"
      opacity={0.1}
    />
    <path
      d="M29.737 16.065a13.873 13.827 0 0 1-13.873 13.827A13.873 13.827 0 0 1 1.991 16.065 13.873 13.827 0 0 1 15.864 2.238a13.873 13.827 0 0 1 13.873 13.827"
      transform="matrix(33.33333 0 0 33.33333 -33.333 -33.333)"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M365.433 486.167a145.267 145.267 0 0 1-45.566-48.067 132.867 132.867 0 0 1-15.6-66.433 119.4 119.4 0 0 1 28.133-80.4 169.333 169.333 0 0 1 73.333-49 283.167 283.167 0 0 1 96-16.167A372.8 372.8 0 0 1 565.6 231a230.6 230.6 0 0 1 44.3 11.433 85.867 85.867 0 0 1 34.667 22.134 44.8 44.8 0 0 1 10.7 29.766A43.133 43.133 0 0 1 644 325.367a37.467 37.467 0 0 1-28.3 11.8 50.967 50.967 0 0 1-21.033-4.734 381.133 381.133 0 0 0-50.1-18.333 181.833 181.833 0 0 0-48.267-6 110.167 110.167 0 0 0-60.467 15.467 50.3 50.3 0 0 0-24.133 45.166 45.433 45.433 0 0 0 12.533 31.767A114.2 114.2 0 0 0 458 424.667q21.233 10.533 63.333 27.933a65.667 65.667 0 0 1 9.067 3.633 449.9 449.9 0 0 1 78.4 40.3 158.067 158.067 0 0 1 48.267 49.534 130.667 130.667 0 0 1 17.433 68.8 138.367 138.367 0 0 1-24.133 82.933 143.467 143.467 0 0 1-67.5 50.1A284.567 284.567 0 0 1 481.4 764.433a319.667 319.667 0 0 1-138.3-26.166 75.267 75.267 0 0 1-28.467-22.134A49.767 49.767 0 0 1 305.367 686a39.367 39.367 0 0 1 12.166-30.667 44.833 44.833 0 0 1 31.367-11.066 80.233 80.233 0 0 1 36.667 9.433q21.066 10.533 33.233 15.8a166.933 166.933 0 0 0 28.667 9.067 164 164 0 0 0 36.833 3.8 98.333 98.333 0 0 0 61.9-16.5 54.5 54.5 0 0 0 20.867-45.2 48 48 0 0 0-13.067-33 138.9 138.9 0 0 0-38.467-28Q490.1 546.267 444 527a443.033 443.033 0 0 1-78.567-40.833"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
)

